module.exports = __webpack_public_path__ + "img/toppng.com-rocket.ca7c7ab9.png";